// extracted by mini-css-extract-plugin
export var callCard = "_s9-0";
export var callMessageButton = "_s9-1";
export var helpIcon = "_s9-3";
export var helpIconContainer = "_s9-4";
export var verticalDivider = "_s9-2";